import { lazy } from 'react';

const EditAdvances = lazy(() => import('./edit'));
const CreateAdvances = lazy(() => import('./create'));

export { EditAdvances, CreateAdvances };
